import { authConstants } from '../constant/auth.constants';
import { auth } from '../services/auth.service';
import CONSTANT from '../constant/constant';
import Cookies from 'universal-cookie';
import functionCommon from "../common/function";

const cookies = new Cookies();
const cookiesName = 'info';
const _errorCode = CONSTANT.errorCode;

export const login = (data) => {
    return dispatch => {
        auth.login(data)
            .then(
                res => { 
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res['result']));
                            functionCommon.setRequestApiTime();
                            setCookie(res['result']);
                            window.location = '/update-working-hour';
                            break;

                        case _errorCode.TOKENExpired:
                            dispatch(logout());
                            break;

                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function setCookie(data) {
        const timestamp = new Date().getTime();
        const expire = timestamp + (60 * 60 * 24 * 1000 * 1);
        const expireDate = new Date(expire);
        cookies.set(cookiesName, data, { expires: expireDate });
    }

    function success(info) { 
        return { type: authConstants.LOGIN_SUCCESS, info }; 
    }
    function failure(error) {
        return { type: authConstants.LOGIN_FAILURE, error }; 
    }
}

export const logout = () => {
    auth.logout();
    return { type: authConstants.LOGOUT };
}

export const clearErrorCode = () => {
    return { type: authConstants.CLEAR_ERROR };
}

export const forgotPassword = (data) => {
    return dispatch => {
        auth.forgotPassword(data)
            .then(
                res => { 
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };
    function success(success) { 
        return { type: authConstants.FORGOT_PASSWORD_SUCCESS, success }; 
    }
    function failure(error) {
        return { type: authConstants.FORGOT_PASSWORD_FAILURE, error }; 
    }
}

export const resetPassword = (data) => {
    return dispatch => {
        auth.resetPassword(data)
            .then(
                res => { 
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            localStorage.setItem("newPass", JSON.stringify(res['result']));
                            dispatch(success('004'));
                            break;

                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        case _errorCode.ClientNotPermission:
                            window.location = '/error/404';
                            break;
    
                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };
    function success(success) { 
        return { type: authConstants.RESET_PASSWORD_SUCCESS, success }; 
    }
    function failure(error) {
        return { type: authConstants.RESET_PASSWORD_FAILURE, error }; 
    }
}

export const resetPassSecretKey = (data) => {
    return dispatch => {
        auth.resetPassSecretKey(data)
            .then(
                res => { 
                    if (!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(failure(''));
                            break;

                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure('secretKey'));
                            break;
                    }
                }
            );
    };
    function failure(error) {
        return { type: authConstants.RESET_SECRETKEY_FAILURE, error }; 
    }
}

export const changePassword = (data) => {
    return dispatch => {
        if (functionCommon.checkRequestApiTime()) {
            return functionCommon.logout();
        } 
        auth.changePassword(data)
            .then(
                res => { 
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            localStorage.setItem("newPass", JSON.stringify(res['result']));
                            dispatch(success('004'));
                            break;
                            
                        case _errorCode.TOKENExpired:
                            dispatch(logout());
                            break;   
                            
                        case _errorCode.APIInvalids:
                            dispatch(logout());
                            break;   

                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };
    function success(success) { 
        return { type: authConstants.CHANGE_PASSWORD_SUCCESS, success }; 
    }
    function failure(error) {
        return { type: authConstants.CHANGE_PASSWORD_FAILURE, error }; 
    }
}
